import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  note: {
    fontWeight: 'bold',
    textAlign: 'left',
    marginTop: theme.spacing(2),
  },
}));

export default function Note(props) {
  const classes = useStyles();

  return (
    <>
      <Typography
        variant="h5"
        component="h5"
        paragraph
        className={classes.note}
      >
        {props.header}
      </Typography>
      <Typography>{props.children}</Typography>
    </>
  );
}
